<template>
  <!--最外层包裹-->
  <v-touch  v-on:swipeup="handleSwiper($event)"  class="wrapper">
    <div class="wrap">
      <Topnav :swipertop="swipertop"></Topnav>
      <div class="content">
        <div class="content-img" ref="imgshow1">
        </div>
        <div class="content-title" ref="imgshow2">
        </div>
        <div class="leftnavbuttom">
           <div class="swpertop"></div>
        </div>
      </div>
    </div>
  </v-touch>
</template>
<script>
  import Topnav from '@/components/topnav.vue'
  import { getUserToken } from '@/config/config.js'
  /*缅怀英烈*/
  export default {
    data() {
      return {
        swipertop:false
      }
    },
    mounted() {
     this._initHomeImgShow()
    },
    methods: {
      _initHomeImgShow() {
        setTimeout(() => {
          this.$refs.imgshow1.classList.add("opacity")
        }, 500)
        setTimeout(() => {
          this.$refs.imgshow2.classList.add("opacity1")
        }, 1000)
      },
      handleSwiper(e){
        console.log(this.swipertop)
        this.swipertop = !this.swipertop
      }
    },
    components:{
      Topnav
    }
  }
</script>
<style lang="scss" scoped>
  @import "index.scss";
</style>




// WEBPACK FOOTER //
// src/pages/Home/index.vue